export enum SnowplowActionTypes {
  VALUE_STRING = "string",
  VALUE_DOUBLE = "double",
  VALUE_INT = "int",
  VALUE_BOOL = "bool",
}

export interface ISnowPlowAbTestAction {
  abTestName: string;
  actionName: string;
  abTestEventId: number;
  valueType?: string;
  valueString?: string;
  valueDouble?: number;
  valueInt?: number;
  valueBool?: boolean;
}

export enum AbTestActionEventProperties {
  AB_TEST_NAME = "ab_test_name",
  ACTION_NAME = "action_name",
  AB_TEST_EVENT_ID = "ab_test_event_id",
  VALUE_TYPE = "value_type",
  VALUE_STRING = "value_string",
  VALUE_DOUBLE = "value_double",
  VALUE_INT = "value_int",
  VALUE_BOOL = "value_bool",
}

/**
 * Converts an A/B test action to a request object
 * @param action - The A/B test action to convert
 * @returns A record object containing the formatted A/B test action properties
 */
export function snowPlowAbTestActionToRequest(
  action: ISnowPlowAbTestAction,
): Record<string, unknown> {
  return {
    [AbTestActionEventProperties.AB_TEST_NAME]: action.abTestName,
    [AbTestActionEventProperties.ACTION_NAME]: action.actionName,
    [AbTestActionEventProperties.AB_TEST_EVENT_ID]: action.abTestEventId,
    ...(action.valueType && {
      [AbTestActionEventProperties.VALUE_TYPE]: action.valueType,
    }),
    ...(action.valueString && {
      [AbTestActionEventProperties.VALUE_STRING]: action.valueString,
    }),
    ...(typeof action.valueDouble === "number" && {
      [AbTestActionEventProperties.VALUE_DOUBLE]: action.valueDouble,
    }),
    ...(typeof action.valueInt === "number" && {
      [AbTestActionEventProperties.VALUE_INT]: action.valueInt,
    }),
    ...(typeof action.valueBool === "boolean" && {
      [AbTestActionEventProperties.VALUE_BOOL]: action.valueBool,
    }),
  };
}
